/**
 * Client-side error logger — POST to Worker /api/log-error → Supabase error_logs table.
 * Use trong catch blocks để debug user issues sau khi event xảy ra.
 *
 * Public endpoint (no auth required) — vẫn forward được error nếu session invalid.
 * Rate-limit per IP (10/min) ở Worker, không cần guard client side.
 */

const WORKER_URL = import.meta.env.VITE_WORKERS_URL || 'http://localhost:8787';

export interface ClientErrorPayload {
  message: string;
  stack?: string;
  /** Action context, vd: 'translate', 'upload_parse', 'export_docx', 'audit', 'react_boundary' */
  action?: string;
  /** Optional context summary, vd: 'fileId=abc fileName=foo.docx batches=13' */
  inputSummary?: string;
  userId?: string | null;
}

export async function logClientError(payload: ClientErrorPayload): Promise<void> {
  try {
    await fetch(`${WORKER_URL}/api/log-error`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        message: payload.message?.slice(0, 500) || 'Unknown error',
        stack: payload.stack?.slice(0, 2000),
        action: payload.action,
        inputSummary: payload.inputSummary?.slice(0, 500),
        userId: payload.userId,
        url: typeof window !== 'undefined' ? window.location.href : undefined,
        userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : undefined,
      }),
      keepalive: true, // ensure send even if page unloading
    });
  } catch {
    // Silent — logging itself failing shouldn't crash app flow
  }
}
